import React, {FC} from "react"

import Flex from "@irati/ui/src/Flex"
import {H4, Label} from "@irati/ui/src/Typography"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import theme from "@irati/ui/src/global/theme"
import {Celebration, CompanyValue} from "@irati/types"
import smallPerkoxLogo from "@irati/ui/images/logo-alt_small.svg"
import Card from "@irati/ui/src/Layout/Card"

import {StyledImg} from "./styled"

interface Props extends InjectIntl {
  title: string
  data: CompanyValue[] | Celebration[]
}

const ValuesAndCelebrationsCard: FC<Props> = ({title, data, formatMessage}) => {
  return (
    <Card bgColor={theme.colors.greys.lightest}>
      <H4 color={theme.colors.greys.mediumDark} marginBottom={2}>
        <FormattedMessage id={title} />
      </H4>
      <Flex wrap="wrap" justifyContent="space-between" gap={theme.spacing.six}>
        {data?.map((value, i) => {
          const iconHref = value.icon?.href && formatMessage({id: value.icon?.href})
          const valueName = value.name && formatMessage({id: value.name})
          return (
            <Flex key={i} direction="column" alignItems="center">
              <StyledImg src={iconHref || smallPerkoxLogo} alt={value.icon?.alt || "perkbox_logo-small"} />
              <Label textAlign="center" marginTop color={theme.colors.greys.mediumDark} small>
                {valueName}
              </Label>
              <H4 color={theme.colors.primary1}>{value.usageCount}</H4>
            </Flex>
          )
        })}
      </Flex>
    </Card>
  )
}

export default injectIntl(ValuesAndCelebrationsCard)
